import { useSkin } from "@hooks/useSkin";
import styled from "styled-components";
import { DataTable } from "components/Structure";

const StyledDataTable = styled(DataTable)`
  .rdt_TableHeadRow {
    border-radius: 0px !important;
    font-weight: 700 !important;
    background: #f3f2f7;
    color: #6e6b7b;
    font-size: 12px;
    text-transform: uppercase;
    margin: 0px;
    min-height: 38px !important;
    background: ${({ skin }) => (skin === "dark" ? "#343d55" : "f3f2f7")};
    color: ${({ skin }) => (skin === "dark" ? "#d0d2d6" : "f3f2f7")};
  }

  .rdt_TableBody {
    padding: 2px 0px;
  }
`;

export const CustomDataTable = props => {
  const { skin } = useSkin();

  return <StyledDataTable {...props} skin={skin} />;
};
